"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useState } from "react";
import HoverCard from "./HoverCard";
import UserProfileTooltip from "@/components/user/utils/profile/UserProfileTooltip";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { ArtistPreviewModal } from "@/components/waves/drops/ArtistPreviewModal";
import type { ApiProfileMin } from "@/generated/models/ApiProfileMin";
import type { ArtistPreviewTab } from "@/hooks/useArtistPreviewModal";
interface UserProfileTooltipWrapperProps {
  readonly user: string;
  readonly children: React.ReactElement;
  readonly placement?: "top" | "bottom" | "left" | "right" | "auto" | undefined;
}
export default function UserProfileTooltipWrapper(t0) {
  const $ = _c(19);
  const {
    user,
    children,
    placement: t1
  } = t0;
  const placement = t1 === undefined ? "auto" : t1;
  const {
    hasTouchScreen
  } = useDeviceInfo();
  let t2;
  if ($[0] !== user) {
    t2 = user.trim();
    $[0] = user;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const trimmedUser = t2;
  const ariaLabel = trimmedUser ? `User profile for ${trimmedUser}` : "User profile";
  const [artistPreview, setArtistPreview] = useState(null);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = params => {
      setArtistPreview({
        user: params.user,
        activeTab: params.initialTab
      });
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleArtistPreviewOpen = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = tab => {
      setArtistPreview(current => {
        if (current === null || current.activeTab === tab) {
          return current;
        }
        return {
          ...current,
          activeTab: tab
        };
      });
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleArtistPreviewTabChange = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setArtistPreview(null);
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const handleArtistPreviewClose = t5;
  if (hasTouchScreen) {
    let t6;
    if ($[5] !== children) {
      t6 = <>{children}</>;
      $[5] = children;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    return t6;
  }
  let t6;
  if ($[7] !== user) {
    t6 = <UserProfileTooltip user={user} onArtistPreviewOpen={handleArtistPreviewOpen} />;
    $[7] = user;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== ariaLabel || $[10] !== children || $[11] !== placement || $[12] !== t6) {
    t7 = <HoverCard content={t6} ariaLabel={ariaLabel} placement={placement} delayShow={500} delayHide={0}>{children}</HoverCard>;
    $[9] = ariaLabel;
    $[10] = children;
    $[11] = placement;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== artistPreview) {
    t8 = artistPreview && <ArtistPreviewModal isOpen={true} onClose={handleArtistPreviewClose} user={artistPreview.user} activeTab={artistPreview.activeTab} onTabChange={handleArtistPreviewTabChange} />;
    $[14] = artistPreview;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}